import { CardAlcoholVSSoap } from '@/components/Cards/CardAlcoholVSSoap';
import { CardCampaingProgress } from '@/components/Cards/CardCampaignProgress';
import { CardCampaignSummary } from '@/components/Cards/CardCampaignSummary';
import { CardForTresholdUsage } from '@/components/Cards/CardForThresholdUsage';
import { CardPhases } from '@/components/Cards/CardPhases';
import { CardTipsSlideshow } from '@/components/Cards/CardTipsSlideshow';
import { Container } from '@/components/Containers/Container';
import { ContainerList } from '@/components/Containers/ContainerList';
import { ErrorRoute } from '@/components/ErrorRoute';
import { CampaignSkeleton } from '@/components/Skeletons/CampaignSkeleton';
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs';
import { queries } from '@/utils/queryOptions';
import { ThresholdKey } from '@frontend/api-client-user/types';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/_protected/campaigns/$campaignId')({
	component: RouteComponent,
	beforeLoad: () => ({ crumb: 'Campaign' }),
	loader: async ({ context, params }) => {
		await context.queryClient.ensureQueryData(
			queries.campaigns.detail(params.campaignId),
		);
		return { ...params, crumb: 'LOL' };
	},
	errorComponent: ErrorRoute,
	pendingComponent: CampaignSkeleton,
});

function RouteComponent() {
	const { setIdNameMap } = useBreadcrumbs();
	const { campaignId } = Route.useLoaderData();
	const { data } = useSuspenseQuery(queries.campaigns.detail(campaignId));

	const start = new Date(data.start);
	const end = data.end ? new Date(data.end) : undefined;

	useEffect(() => {
		setIdNameMap(data.id, data.name);
	}, []);

	const hmm = data.data.reduceRight(
		(acc, curr) => {
			if (!curr.dataLevel) return acc;
			acc[curr.dataLevel] += 1;

			return acc;
		},
		{
			High: 0,
			Medium: 0,
			Low: 0,
		} as Record<ThresholdKey, number>,
	);

	return (
		<>
			<ContainerList>
				<CardCampaingProgress start={start} end={end} status={data.status} />
				<CardCampaignSummary days={hmm} />
				<CardAlcoholVSSoap soap={data.soapUsage} alcohol={data.alcoholUsage} />
				<CardTipsSlideshow />
			</ContainerList>
			<Container>
				<CardForTresholdUsage
					chartData={data.data}
					upperThreshold={data.upperThreshold}
					lowerThreshold={data.lowerThreshold}
				/>
			</Container>
			<Container className="grid grid-cols-1 @xl/main:grid-cols-2 gap-4">
				<CardPhases items={data.phases} />
			</Container>
		</>
	);
}
